import { Radio } from "antd";

const RadioComponent = ({ onChange, options, label, value, id }) => {
  const handleChange = (e) => {
    onChange(id, e.target);
  };

  return (
    <div>
      <p>{label}</p>
      <Radio.Group onChange={handleChange} value={value} name={id}>
        {options.map((item, index) => {
          return (
            <Radio key={index} value={item.value}>
              {item.label}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default RadioComponent;
